/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Client } from './';
import {
    ClientFromJSON,
    ClientFromJSONTyped,
    ClientToJSON,
} from './';
import type { ContractType } from './';
import {
    ContractTypeFromJSON,
    ContractTypeFromJSONTyped,
    ContractTypeToJSON,
} from './';
import type { FixedPriceProjectContractResource } from './';
import {
    FixedPriceProjectContractResourceFromJSON,
    FixedPriceProjectContractResourceFromJSONTyped,
    FixedPriceProjectContractResourceToJSON,
} from './';
import type { Freelancer } from './';
import {
    FreelancerFromJSON,
    FreelancerFromJSONTyped,
    FreelancerToJSON,
} from './';
import type { TimeAndMaterialsProjectContractResource } from './';
import {
    TimeAndMaterialsProjectContractResourceFromJSON,
    TimeAndMaterialsProjectContractResourceFromJSONTyped,
    TimeAndMaterialsProjectContractResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProjectContractResource
 */
export interface ProjectContractResource {
    /**
     * 
     * @type {string}
     * @memberof ProjectContractResource
     */
    id: string;
    /**
     * 
     * @type {Client}
     * @memberof ProjectContractResource
     */
    client: Client;
    /**
     * 
     * @type {Freelancer}
     * @memberof ProjectContractResource
     */
    freelancer: Freelancer;
    /**
     * 
     * @type {string}
     * @memberof ProjectContractResource
     */
    conversationId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectContractResource
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectContractResource
     */
    freelancerTermsAndConditions?: string;
    /**
     * 
     * @type {ContractType}
     * @memberof ProjectContractResource
     */
    type: ContractType;
    /**
     * 
     * @type {string}
     * @memberof ProjectContractResource
     */
    pdfUrl?: string;
}

/**
 * Check if a given object implements the ProjectContractResource interface.
 */
export function instanceOfProjectContractResource(value: object): value is ProjectContractResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('client' in value) || value['client'] === undefined) return false;
    if (!('freelancer' in value) || value['freelancer'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function ProjectContractResourceFromJSON(json: any): ProjectContractResource {
    return ProjectContractResourceFromJSONTyped(json, false);
}

export function ProjectContractResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectContractResource {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['type'] === 'FIXED_PRICE') {
            return FixedPriceProjectContractResourceFromJSONTyped(json, true);
        }
        if (json['type'] === 'TIME_AND_MATERIALS') {
            return TimeAndMaterialsProjectContractResourceFromJSONTyped(json, true);
        }
    }
    return {
        
        'id': json['id'],
        'client': ClientFromJSON(json['client']),
        'freelancer': FreelancerFromJSON(json['freelancer']),
        'conversationId': json['conversationId'] == null ? undefined : json['conversationId'],
        'title': json['title'],
        'freelancerTermsAndConditions': json['freelancerTermsAndConditions'] == null ? undefined : json['freelancerTermsAndConditions'],
        'type': ContractTypeFromJSON(json['type']),
        'pdfUrl': json['pdfUrl'] == null ? undefined : json['pdfUrl'],
    };
}

export function ProjectContractResourceToJSON(value?: ProjectContractResource | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
        if (value.type === 'FIXED_PRICE') {
            return FixedPriceProjectContractResourceToJSON(value as FixedPriceProjectContractResource);
        }
        if (value.type === 'TIME_AND_MATERIALS') {
            return TimeAndMaterialsProjectContractResourceToJSON(value as TimeAndMaterialsProjectContractResource);
        }
    }
    return {
        
        'id': value['id'],
        'client': ClientToJSON(value['client']),
        'freelancer': FreelancerToJSON(value['freelancer']),
        'conversationId': value['conversationId'],
        'title': value['title'],
        'freelancerTermsAndConditions': value['freelancerTermsAndConditions'],
        'type': ContractTypeToJSON(value['type']),
        'pdfUrl': value['pdfUrl'],
    };
}

